module.exports = __webpack_public_path__ + "img/swag-admin-3.f08c3975.png";